import React from 'react';
import cn from 'classnames';

import Modal from '../Modal';
import Button from '../../forms/Button';

import styles from './styles.module.css';

const WarningModal = ({
  title,
  text,
  noText = 'Back',
  yesText = 'Yes',
  onClose,
  onConfirm,
  isOpen,
}) => {
  return (
    <Modal
      title={title}
      modalClassName={styles.modalClassName}
      onClose={onClose}
      isOpen={isOpen}
    >
      <div className={styles.modalContent}>
        <header className={styles.header}>
          <div className={styles.title}>{title}</div>
        </header>
        <p className={styles.text}>{text}</p>
        <div className={styles.buttonsWrapper}>
          <Button className={cn(styles.btn, styles.yesBtn)} onClick={onConfirm}>
            {yesText}
          </Button>
          <Button
            onClick={onClose}
            className={cn(styles.btn, styles.noBtn)}
          >
            {noText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
